import style from './cardMobileStyle.module.css';

const CardMobileCompo = (props) => {
  return (
    <div className={style.mobileCard}>
      <div
        className={`row row-cols-2 row-cols-md-2 g-4 ${style.rowMobileCard}`}
      >
        <div className="col">
          <div className={`card ${style.cards}`}>
            <a href="/#">
              <img src={props.image} className="card-img-top" alt="Tipe Rumah" />
              <div className={`card-img-overlay ${style.card1}`}>
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.address}</p>
              </div>
            </a>
          </div>
        </div>
        <div className="col">
          <div className={`card ${style.cards}`}>
            <a href="/#">
              <img src={props.image} className="card-img-top" alt="..." />
              <div className={`card-img-overlay ${style.card2}`}>
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.address}</p>
              </div>
            </a>
          </div>
        </div>
        <div className="col">
          <div
            className={`card ${style.cards}`}
            style={{ 'marginTop': '-10px' }}
          >
            <a href="/#">
              <img src={props.image} className="card-img-top" alt="..." />
              <div className={`card-img-overlay ${style.card3}`}>
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.address}</p>
              </div>
            </a>
          </div>
        </div>
        <div className="col">
          <div
            className={`card ${style.cards}`}
            style={{ 'marginTop': '-90px' }}
          >
            <a href="/#">
              <img src={props.image} className="card-img-top" alt="..." />
              <div className={`card-img-overlay ${style.card4}`}>
                <h5 className="card-title">{props.title}</h5>
                <p className="card-text">{props.address}</p>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardMobileCompo;
